<template>
  <div class="content">
    <el-row class="content-head">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <!-- <el-breadcrumb-item>考勤管理</el-breadcrumb-item> -->
            <el-breadcrumb-item style="margin-left:10px">访客管理系统</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container class="content-container">
      <el-main style="height:100%;padding:0px !important;  position: relative;width: 100%;">
        <el-card style="height:100% !important;" class="aside">
          <!-- 上 -->
          <div class="search-section">
            <div style="display:flex;align-items:center"> 
              <div style="display:flex;align-items:center;margin-left:8px">
                <el-input v-model="search.name" placeholder="请输入姓名" clearable>
                  <el-button slot="append" icon="el-icon-search" @click="doFilter"></el-button>
                </el-input>
              </div>
                <div style="display:flex;align-items:center;margin-left:20px">
                <el-input v-model="search.phone" placeholder="请输入手机号" clearable>
                  <el-button slot="append" icon="el-icon-search" @click="doFilter"></el-button>
                </el-input>
              </div>
            </div>
            
            <!-- <div style="display:flex;align-items:center">
              <el-button  type="success" v-if="search.isEffective==0"  @click="agree(1)" >批量通过</el-button>
              <el-button  type="danger"  v-if="search.isEffective==0" @click="agree(2)" >批量不通过</el-button>
            </div> -->

            <!-- <el-tooltip class="item" effect="dark" content="导出" placement="top-end"
              v-if="isMenuExit('pro:record:export')">
              <img class="icon_hover" @click="exportWorker" src="../../assets/image/export.png" alt="" srcset="">
            </el-tooltip> -->
          </div>
          <div>
            <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
              <el-menu-item index="0" @click="change(0)" 
              :class="{ cur: search.status == 0 }"
              >待下发</el-menu-item>
              <el-menu-item index="1" @click="change(1)" 
              :class="{ cur: search.status == 1 }"
              >下发成功</el-menu-item>
              <el-menu-item index="2" @click="change(2)"
              :class="{ cur: search.status == 2 }"
              >下发失败</el-menu-item>
            </el-menu>
          </div>
          <!-- 表格 -->
          <div class="build-table">
            <el-table stripe :data="listData" height="100%" style="width: 100%;"
              @selection-change="handleSelectionChange" :header-cell-style="{background:'#F5F7F9',color:'#909399'}"
              >

              <template slot="empty">
                <p>{{dataText}}</p>
              </template>
              <!-- <el-table-column type="selection" width="55">
              </el-table-column> -->
              <el-table-column label="序号" width="100" center>
                <template slot-scope="scope">
                  <a style="padding-left:1vw;">{{ scope.row.index}}</a>
                </template>
              </el-table-column>
              <el-table-column label="姓名" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.name }}【{{ scope.row.imei }}】</span>
                </template>
              </el-table-column>
                <el-table-column label="手机号" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.phone }}</span>
                </template>
              </el-table-column>
                <el-table-column label="身份证号" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.idCard }}</span>
                </template>
              </el-table-column>
                <el-table-column label="门禁卡号" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.icCard }}</span>
                </template>
              </el-table-column>
                <el-table-column label="是否删除" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.delFlag==0?'否':'是' }}</span>
                </template>
              </el-table-column>
             
              <el-table-column label="身份证头像" align="center">
                <template slot-scope="scope">
                  <!-- <img
                    v-if="scope.row.facePhoto!=''"
                    :src="scope.row.facePhoto"
                    style="width:70px;height:90px;"
                  /> -->
                  <div style="display:flex;align-items: center;align-content: center; justify-content: space-around;">
                    <el-image 
                    v-if="scope.row.idCardPhoto!=''"
                    style="width:70px;height:90px;"
                    :src="scope.row.idCardPhoto" 
                    :preview-src-list="[scope.row.idCardPhoto]">
                  </el-image>
                    <div v-else style="width:3.5vw;height:9vh;background: #ddd;display: flex;align-items: center;   justify-content: space-around;">暂无图片</div>
                   </div>
                </template>
              </el-table-column>
              <el-table-column label="采集头像" align="center">
                <template slot-scope="scope">
                  <!-- <img
                    v-if="scope.row.facePhoto!=''"
                    :src="scope.row.facePhoto"
                    style="width:70px;height:90px;"
                  /> -->
                  <div style="display:flex;align-items: center;align-content: center; justify-content: space-around;">
                    <el-image 
                    v-if="scope.row.facePhoto!=''"
                    style="width:70px;height:90px;"
                    :src="scope.row.facePhoto" 
                    :preview-src-list="[scope.row.facePhoto]">
                  </el-image>
                    <div v-else style="width:3.5vw;height:9vh;background: #ddd;display: flex;align-items: center;   justify-content: space-around;">暂无图片</div>
                   </div>
                </template>
              </el-table-column>
                <el-table-column label="开始时间" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.startDate }}</span>
                </template>
              </el-table-column>
                <el-table-column label="结束时间" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.endDate }}</span>
                </template>
              </el-table-column>
              <el-table-column label="原因" v-if="search.status==2">
                <template slot-scope="scope">
                  <span>{{scope.row.message}}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="el-end">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page="currentPage" :page-sizes="[10,20, 60, 80, 100]" :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper" :total="totalItems"></el-pagination>
          </div>
        </el-card>
      </el-main>
    </el-container>
    <!-- 上传提示 -->
    <el-dialog title="提示" :visible.sync="tipVis" width="30%" :close-on-click-modal="false">
      <el-table ref="singleTable" :data="tipList" style="width: 100%">
        <el-table-column type="index" label="序号" width="80"></el-table-column>
        <el-table-column property="status" label="状态" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.status=='1'" style="color:#F56C6C;">失败</span>
            <span v-else-if="scope.row.status=='0'" style="color:#67C23A;">成功</span>
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column property="reason" label="信息">
          <template slot-scope="scope">
            <span v-if="scope.row.status=='1'" style="color:#F56C6C;">{{scope.row.reason}}</span>
            <span v-else-if="scope.row.status=='0'" style="color:#67C23A;">{{scope.row.reason}}</span>
            <span v-else>{{scope.row.reason}}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 修改窗口 -->
    <el-dialog :title="dialogTitle" :visible.sync="editFormVisible2" center :append-to-body="true"
      :before-close="handleClose" :lock-scroll="false" width="30%">
      <el-form :model="addForm" ref="addForm" label-width="200px" :label-position="labelPosition">
        <el-form-item label="不通过原因:">
          <el-input v-model="addForm.verifyWhy" type="textarea" autocomplete="off" placeholder="请输入原因"
            style="width: 220px" :rows="4"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editFormVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="sumbitAddRow2('addForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 导出弹出框 -->
    <el-dialog :title="dialogTitle1" :visible.sync="imoportVisible" center :append-to-body="true"
      :before-close="handleClose1" :lock-scroll="false" width="30%">
      <template>
        <el-table :data="tableData1" style="width: 100%" border>
          <el-table-column label="状态" width="300">
            <template slot-scope="scope">
              <span v-if="scope.row.code == 200">
                <i class="el-icon-circle-check" style="color: #07c160"></i>
              </span>
              <span v-else>
                <i class="el-icon-warning-outline" style="color: #f00"></i>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="reason" label="审核不通过结果">
            <template slot-scope="scope">
              <span v-if="scope.row.code == 200" style="color: #07c160">{{
                scope.row.msg
                }}</span>
              <span v-else style="color: #f00">{{ scope.row.msg }}</span>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </el-dialog>
  </div>

</template>
<script>
  import myHttp from '../../untils/port.js'
  import util from '../../untils/util.js'
  import base from '../../untils/base'
  export default {
    data() {
      return {
        labelPosition: 'right',
        activeIndex: '0',
        search: {
          //查询
          name: '',
          projectId: '',
            status:0
        },
        listData: [], //表格数据
        tableData1: [],
        dataText: '数据加载中...',
        currentPage: 1,
        pageSize: 10,
        totalItems: 0,
        dialogTitle: '',
        addFormVisible: false,
        addForm: {
          id: '',
          name: '',
          phone: '',
          list: [],//角色列表
          roleIds: '',
          facePhoto: '',
          position: ''
        },
       
        posts: [],//职务
        // types:[],//进出类型
        //导入
        uploadUrl: myHttp.importSchoolTeacherPersonExcel,
        uploadHead: {
          accessToken: util.session.get('token')
        },
        uploadData: {
          projectId: util.session.get('groupId')
        },
        uploadUrl1: base.url + '/schoolWeb/upload/uploadPhoto', //上传地址
        uploadHead1: {
          accessToken: util.session.get('token')
        },
        tipList: [],
        tipVis: false,
        authList: [],
        icon: '',
        rules: {

        },
        multipleSelection: [],
        addForm: {
          id: '',
          verifyWhy: '',
        },
        dialogTitle: '',
        dialogTitle1: '审核结果',
        multipleSelection: [],
        editFormVisible: false,
        editFormVisible2: false,
        imoportVisible: false,
        ids: '', //批量操作的id
        gradeArry:[],//班级列表
        classArry:[],//年级列表
      }
    },

    created() {
      // if (util.session.get('roleId') == '4') {
      //   this.search.projectId = util.session.get('groupId')
      // } else {
      //   this.search.projectId = util.session.get('proId')
      // }
       this.groupId = util.session.get('groupId')
       
    },
    mounted() {
      //this.search.projectId = util.session.get('groupId')
      // if (this.search.projectId == '') {
      //   this.$store.commit('setGroupId')
      //   this.search.projectId = this.$store.state.groupId
      // }
      // console.log(this.search.projectId)
      // if (util.session.get('roleId') == '4') {
      //   this.search.projectId = util.session.get('groupId')
      // } else {
      //   this.search.projectId = util.session.get('proId')
      // }
       this.groupId = util.session.get('groupId')
       this.search.projectId =  this.groupId
      this.getDict() //获取考勤
      this.getData()
      // this.teamTree()
    },
    methods: {
      handleSelect(key, keyPath) {
        console.log(key, keyPath)
      },

      getDict() {
        var that = this
        myHttp
          .getDictByType({
            type: 'position'
          })
          .then(function (resp) {
            if (resp.data.code == '200') {
              var list = resp.data.data.dictList || []
              for (var i = 0; i < list.length; i++) {
                list[i].text = list[i].label
              }
              that.posts = list
            } else {
              that.$message.error(resp.data.msg)
            }
          })
      },
      //获取类型
      filterSatus(str) {
        var list = this.posts
        var result = ''
        for (var i = 0; i < list.length; i++) {
          if (str == list[i].value) {
            result = list[i].label
          }
        }
        return result
      },
      /**批量下发**/
      sendOut() {



      },
      // 通过审核
      personInfo(row) {
        // console.log(row)
        var that = this
        this.$confirm('确定同意, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            myHttp
              .auditPerson({
                idStr: row.schoolStudentPersonId,
                status: '1',
                projectId:this.search.projectId
              })
              .then(function (resp) {
                if (resp.data.code == '200') {
                  that.getData()
                  that.$message.success('操作成功')
                  // that.imoportVisible = true
                  // that.tableData1 = resp.data.data.list
                  // that.addForm.landlordStatus = 1
                }
              })
          })
          .catch((err) => { })
      },
      // 关闭弹出框弹窗
      handleClose(done) {
        this.editFormVisible = false
        this.editFormVisible2 = false
      },
      handleClose1(done) {
        this.imoportVisible = false
      },
      //修改信息
      editFun(row) {
        ; (this.dialogTitle = '审核不通过'), (this.addForm.id = row.schoolStudentPersonId)
        this.addForm.verifyWhy = row.location
        this.editFormVisible2 = true
        // var that = this
        // this.$confirm('确定不同意, 是否继续?', '提示', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   type: 'warning',
        // })
        //   .then(() => {
        //     myHttp
        //       .auditPerson({
        //         projectId:this.search.projectId,
        //         idStr: row.schoolStudentPersonId,
        //         isEffective: '2',
        //       })
        //       .then(function (resp) {
        //         if (resp.data.code == '200') {
        //           that.getData()
        //           that.$message.success('操作成功')
        //           // that.imoportVisible = true
        //           // that.tableData1 = resp.data.data.list
        //           // that.addForm.landlordStatus = 1
        //         }else{
        //           that.$message.error(resp.data.msg)
        //         }
        //       })
        //   })
        //   .catch((err) => { })
      },
      // 搜索数据
      doFilter() {
        // this.search.startDate = this.date ? this.date[0] : ''
        // this.search.endDate = this.date ? this.date[1] : ''
        this.currentPage = 1
        this.getData()
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.handleCurrentChange(this.currentPage)
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.currentChangePage()
      },
      //监控当前页码
      currentChangePage(list) {
        this.getData()
      },
      // 获取数据
     getData() {
        var that = this
        this.search.pageNum = this.currentPage
        this.search.pageSize = this.pageSize
        this.search.projectId = this.groupId
        myHttp.getVisVisitorCmdPage(this.search).then(
          function (resp) {
            if (resp.data.code == '200') {
              console.log(resp)
              var list = resp.data.data.visVisitorCmdsPage.list || []
              for (var i = 0; i < list.length; i++) {
                list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
                list[i].facePhoto = list[i].facePhoto && list[i].facePhoto != '' ? base.httpCtx + list[i].facePhoto +'?v='+new Date().getTime(): ''
                list[i].idCardPhoto = list[i].idCardPhoto && list[i].idCardPhoto != '' ? base.httpCtx + list[i].idCardPhoto +'?v='+new Date().getTime(): ''
                // list[i].typeName = that.filterSatus(list[i].status)
                // list[i].idcardPhoto = list[i].idcardPhoto && list[i].idcardPhoto!=''?base.httpCtx+list[i].idcardPhoto:''
                // list[i].createDate = list[i].createDate && list[i].createDate!=''?list[i].createDate.split(' ')[0]:''
                // list[i].age = util.myTime.getAge(list[i].birthday)
              }
              that.listData = list
              that.totalItems = resp.data.data.visVisitorCmdsPage.total 
              //that.getTypeName()
              if (that.listData.length == 0) {
                that.dataText = '暂无数据'
              }
            } else {
              that.$message.error(resp.data.msg)
              that.dataText = '暂无数据'
            }
          },
          function () { }
        )
      }, 
      // 改变审核状态
      // change(isEffective) {
      //   console.log(isEffective)
      //   this.opt.isEffective = isEffective
      //   this.doFilter()
      // },
      // 批量
      agree(verifyWhy) {
        if (verifyWhy == '1') {
          var that = this
          this.$confirm('确定同意, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              myHttp
                .auditPerson({
                  idStr: this.ids,
                  status: verifyWhy,
                  projectId:this.search.projectId
                })
                .then(function (resp) {
                  if (resp.data.code == '200') {
                    that.getData()
                    that.$message.success('操作成功')

                  }
                })
            })
            .catch((err) => { })
      }else{
        this.editFormVisible2 = true
       }
      },
    


      /**
       * 判断是否展示
       */
      isMenuExit(row) {
        var flag = util.common.filterBtnMenu(row)
        return flag
      },

     
      //上传前
      beforeAvatarUpload(file) {

      },


      // 多选数据
      handleSelectionChange(val) {
        this.multipleSelection = val;
        for (var i = 0; i < val.length; i++) {
        if (i == 0) {
          this.ids = val[i].schoolStudentPersonId
        } else {
          this.ids += ',' + val[i].schoolStudentPersonId
        }
      }
      console.log(this.ids)
      },
      // 改变审核状态
      change(status) {
        console.log(status)
        if(status == 0){
          this.search.status = ''
        }else{
          this.search.status = status
        }
        
        this.doFilter()
      },
    
    }
  }
</script>
<style>
  @import '../../assets/css/common.css';
</style>
<style scoped>
  .content>>>.el-card__body {
    padding: 0 !important;
    height: 100% !important;
  }

  .grid-content {
    height: 2.5vh;
    font-size: 1.6vh;
  }

  .aside {
    box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
    border-radius: 10px !important;
    border: 0px !important;
    background-color: rgb(255, 255, 255);
    display: flex;
    flex-direction: column;
  }

  .search-section {
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin: 20px 35px 20px 10px;
    height: 40px;
    justify-content: space-between;
  }

  .el-end {
    height: 47px;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    text-align: center;
  }

  .build-table {
    height: calc(100% - 207px);
    width: 98%;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
  }

  .el-pagination {
    margin: auto;
  }

  .el-table--fit {
    border-bottom: 1px solid #f5f5f5;
  }

  .content>>>.el-input-group--append .el-input__inner {
    width: 200px;
  }

  .avatar {
    width: 100%;
  }
</style>